'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var parseArrayValue = function parseArrayValue(breaks) {
  return function (values) {
    return function (createStyle) {
      if (!Array.isArray(values)) {
        return createStyle(values);
      }

      var breakpoints = [null].concat(_toConsumableArray(breaks));
      var styles = values.map(function (value, i) {
        var breakpoint = breakpoints[i];
        if (value === null) {
          return null;
        }

        if (!breakpoint) {
          return createStyle(value);
        }

        return _defineProperty({}, breakpoint, createStyle(value));
      });

      return _objectAssign2.default.apply(undefined, [{}].concat(_toConsumableArray(styles)));
    };
  };
};

exports.default = parseArrayValue;